module.exports = __webpack_public_path__ + "static/media/A2.b0a9abb2.jpg";